export default {
  main: '#E4032E',
  secondary: '#161616',
  contrastingColor: '#ffffff',
  priceColor: '#E4032E',
  entryBackground: '#000000',
  menuBackgroundColor: '#ffffff',
  menuTextColor: '#000000',
};
